import type { NextPage } from "next";
import dynamic from "next/dynamic";

import Page from "components/layout/page";
import NextSectionAction from "components/next-section-action";
import Access from "components/views/reporting/access";
import AiInsights from "components/views/reporting/ai-insights";
import ImportantData from "components/views/reporting/important-data";
import Investment from "components/views/reporting/investment";
import MainHero from "components/views/reporting/main-hero";
import YourData from "components/views/reporting/your-data";

const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));

const Reporting: NextPage = () => (
  <Page
    title="Solar Reporting & Analytics Software | AI-Powered"
    description="Enerflo’s AI-powered reporting suite helps residential solar companies analyze performance, track KPIs, and make data-driven decisions."
  >
    <MainHero />
    <Investment />
    <YourData />
    <AiInsights />
    <ImportantData />
    <Access />
    {/* TODO: Uncomment if/when this RSMI offering is available again */}
    {/* <NextSectionAction
      buttonText="View Residential Solar Market Intelligence"
      url="/features/residential-solar-market-intelligence"
      description="Get access to live installer data"
    /> */}

    <NextSectionAction
      buttonText="View Integrations"
      url="/integrations"
      description="Integrate your favorite tools in your version of Enerflo"
    />
    <DemoFormSection />
  </Page>
);

export default Reporting;
